function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#232F63;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#7BADC9;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#6197AA;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#9E2632;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#C1DEE8;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#660E17;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#1C3156;}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#F2F2F2;}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#CEECF4;}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#053C52;}\r\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#0F1A42;}\r\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#BAD4E8;}\r\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#EAF2F9;}\r\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#01567A;}\r\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#BFD6E4;}\r\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#1F334D;}\r\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:#4D7A8E;}\r\n\t.st18{clip-path:url(#SVGID_00000014603069912606425280000018159669249815719606_);}\r\n\t\r\n\t\t.st19{clip-path:url(#SVGID_00000151505328100916773660000002372582328068571524_);fill-rule:evenodd;clip-rule:evenodd;fill:#BAD4E8;}\r\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#FAC2AE;}\r\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#EAA48F;}\r\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#F1A080;}\r\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:#E18025;}\r\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#009FDA;}\r\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#78ADC4;}\r\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#669EB2;}\r\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#E6515B;}\r\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#8CBDD3;}\r\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:#83B6CC;}\r\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#D3404E;}\r\n\t.st31{fill:none;stroke:#6EADCD;}\r\n\t.st32{fill:none;stroke:#000000;stroke-width:0.9;}\r\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#F2F6F7;}\r\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#DAE2E5;}\r\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:#132147;}\r\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:#192654;}\r\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:#EBF4F7;}\r\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:#A55926;}\r\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:#BC672D;}\r\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:#C9B3A9;}\r\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:#43A035;}\r\n\t.st42{fill:#FFFFFF;}\r\n\t.st43{font-family:'ArialMT';}\r\n\t.st44{font-size:20px;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  className: "st0",
  points: "304.8,501.5 505.7,501.5 505.7,217 304.8,217  "
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  className: "st1",
  points: "300.2,498 501.1,498 501.1,213.6 300.2,213.6  "
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-3",
  className: "st2",
  d: "M564.7,148.4l200,197.4c0-3.6-0.1-7.3-0.1-10.9c0-1.3-0.1-2.7-0.1-4 c0.1-14.6,0.1-29.1,0.2-43.7c0-0.9,0-1.9-0.1-2.8c0-36.3,0-72.5,0-108.8c0-20.6,0.1-41.3,0.1-61.9c0-15.6,0-31.2,0-46.9 l-200,16.5L564.7,148.4L564.7,148.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  className: "st3",
  points: "299.9,212.8 501,212.8 417.1,496.7 299.9,496.7  "
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  className: "st2",
  points: "317.1,453 481.7,453 481.7,229.3 317.1,229.3  "
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  className: "st4",
  points: "348.5,240.1 450.2,240.1 450.2,208.5 348.5,208.5  "
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-10",
  className: "st4",
  d: "M400.4,211.3c-6,0-10.8-4.9-10.8-10.8c0-6,4.9-10.8,10.8-10.8c6,0,10.8,4.9,10.8,10.8 C411.3,206.4,406.4,211.3,400.4,211.3 M400.4,181.8c-10.3,0-18.7,8.4-18.7,18.7s8.4,18.7,18.7,18.7c10.3,0,18.7-8.4,18.7-18.7 S410.7,181.8,400.4,181.8"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  className: "st5",
  points: "340.9,365 456.2,365 456.2,358.2 340.9,358.2  "
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  className: "st5",
  points: "340.9,376.7 456.2,376.7 456.2,370 340.9,370  "
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  className: "st5",
  points: "340.9,392.2 456.2,392.2 456.2,385.5 340.9,385.5  "
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  className: "st5",
  points: "340.4,405 455.7,405 455.7,398.3 340.4,398.3  "
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-15",
  className: "st6",
  points: "348.5,240.1 450.2,240.1 450.2,226.9 348.5,226.9  "
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  className: "st2",
  points: "51.6,25 51.6,491.3 263.1,472 263.1,40.3  "
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-17",
  className: "st7",
  d: "M46.8,64.4l220.7,18.1v-35c0,0,9.5-14.7-36.3-19.8S46.8,18.9,46.8,18.9V64.4z"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-18",
  className: "st8",
  points: "54.8,333.8 266.3,125.1 266.3,459.6 54.8,491.3  "
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-19",
  className: "st9",
  points: "54.8,430.2 266.3,323.1 266.3,459.6 54.8,491.3  "
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-20",
  className: "st10",
  points: "248.9,477.5 263.3,477.5 263.3,40.3 248.9,40.3  "
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-21",
  className: "st11",
  d: "M36.8,128.9c0,4.5-2.1,8.2-4.8,8.2c-2.6,0-4.8-3.7-4.8-8.2s2.1-8.2,4.8-8.2 S36.8,124.4,36.8,128.9"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-22",
  className: "st12",
  d: "M51.6,122c0,4.5-2.1,8.2-4.8,8.2c-2.6,0-4.8-3.7-4.8-8.2s2.1-8.2,4.8-8.2 S51.6,117.5,51.6,122"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-23",
  className: "st2",
  d: "M66.7,115.7c0,4.5-2.1,8.2-4.8,8.2c-2.6,0-4.8-3.7-4.8-8.2s2.1-8.2,4.8-8.2 S66.7,111.2,66.7,115.7"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-24",
  className: "st10",
  d: "M31.6,317.4c-0.7,0-1.4,0-2.1,0v-69.2c0.7,0,1.4,0,2.1,0V317.4z M157.1,510 c-16.6,1-19.3-0.4-20-8c-0.8-8.6,3.8-12.5,15.3-13.4c7.2-0.6,14.3-1.3,21.5-2c6.9-0.7,12.5,0.5,12.7,9.1 c0.2,7.8-3.5,12-11.5,12.5C167.9,508.7,160.8,509.6,157.1,510L157.1,510z M24.7,464.7c0.3,15,1.1,30,0.8,45 c-0.3,15.5,5.3,27,18.9,34.6c1.9,0.4,3.8,0.7,5.7,1.1c7.4,0.5,97.2-12.6,144.9-16.3c15.4-2,30.7-4.2,46.1-5.8 c18.4-1.9,26.1-8.1,28.5-26.9c1.4-11,0.4-22.3,0.5-33.5c-3.6-1.1-7.2-2.1-10.8-3.2c-1.9,0.4-187.7,16.7-194,17.3 c-6.2,1.8-9.5,0.2-9.3-7c0.2-8.2-0.2-16.4-0.3-24.6c-9.7,3.1-12.2-0.7-12.2-10.4c0.3-60.5,0.1-120.9,0-181.4 c0-72.8,0.3-145.6-0.3-218.4C43.1,19,48.9,8.3,62.9,1.4C40.5-2.8,27.2,7.2,25.8,29.7c-2.9,44.6-0.3,89.2-1.3,133.8L24.7,464.7z "
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-25",
  className: "st13",
  d: "M163.2,514.1c-16.6,1-19.3-0.4-20-8c-0.8-8.6,3.8-12.6,15.3-13.4c7.2-0.6,14.3-1.3,21.5-2 c6.9-0.7,12.5,0.5,12.7,9.1c0.2,7.8-3.5,12-11.5,12.5C174,512.8,166.9,513.7,163.2,514.1"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-26",
  className: "st14",
  d: "M246,461L65.3,477c0,0-9.2,2.8-9.2-4.6l-0.2-56.1c0.3-32.6,0.5-65.2,0.8-97.8 c0-1.3,0.1-2.5,0.1-3.8c-0.1-13.8-0.1-27.5-0.2-41.3c0-0.9,0-1.8,0.1-2.6c0-34.3,0-68.5,0-102.8c0-19.5-0.1-39-0.1-58.5 c0-22,0-43.9-0.1-65.9c0-6.3,1.2-10.9,9-9.7c1.8,0,3.6-0.1,5.4,0.1c36.8,3.6,73.6,7.2,110.5,10.9c21.1,2.1,42.2,4.4,63.3,6.4 c8.9,0.9,14.1,3.5,13.9,14.5c-0.3,13,2.2,80.9,0.6,102.4c1.1,18.6,1,37.2,0.2,55.8c0.1,0.7-0.3,122.6-0.3,122.6 c-0.2,10.4-0.4,106.6-0.3,107.3c0,0.1,0,0.2,0,0.3C258.7,455.5,258.1,459.9,246,461 M271.3,348.9h0.2l-0.1-30.4 c0-18,0.1-35.9,0.1-53.9c-0.1,0-0.2-0.1-0.3-0.1l-0.2-69.2l0,0c0-35.1,0.1-70.2,0.1-105.3c-0.1-10.4-0.1-20.8-0.2-31.3 c-0.2-25.1-10.4-35.8-35.4-38C219.7,19.5,124.7,8.1,95.9,4.6c-11-1.3-22-2.2-33-3.2C48.9,8.3,43.1,19,43.2,35.2 c0.7,72.8,0.3,145.6,0.3,218.4c0,60.5,0.3,120.9,0,181.4c0,1.1,0,2.1,0.1,3.1v92.6c0,0-2.4,18.4,24.6,12.9L248,522.3 c0,0,20.1,0.8,22.3-29C270.3,493.3,271.2,379.5,271.3,348.9"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-27",
  className: "st7",
  d: "M745.8,34c-1.8,0-3.6-0.1-5.4,0.1c-36.8,3.6-73.6,7.2-110.5,10.9 c-21.1,2.1-42.2,4.4-63.3,6.4c-0.4,0-0.8,0.1-1.1,0.1v29.3l189.2-15.5c0-7.2,0-14.4,0.1-21.6C754.8,37.4,753.5,32.8,745.8,34"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-28",
  className: "st15",
  d: "M565.5,332l189.7,96v-11.7c-0.2-29.2-0.5-58.3-0.7-87.5l-189-186.5V332z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-29",
  className: "st16",
  d: "M565.5,461c0,0,187.5,23.7,188.2,15.2c2.4-1.1,1.4-13.1,1.4-15l0.1-33.1l-189.7-96V461z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-30",
  className: "st17",
  d: "M565.5,142.3V80.8V51.5c-8.3,1-13.4,3.9-12.7,14.4c0.7,12.5-0.2,25.2-0.8,37.7 c-0.9,21.6-1.5,43.1,0.2,64.7c-1.1,18.6-1,37.2-0.2,55.8c-0.1,0.7-0.1,1.5-0.2,2.2c-0.1,0.1-0.1,0.1-0.2,0.2l0.7,120.2 c0.3,84.4,0.4,106.6,0.3,107.3c0,0.1,0,0.2,0,0.3c-0.1,1.2,0.5,5.6,12.6,6.7h0.3V332L565.5,142.3L565.5,142.3z"
});

var _ref31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_1_",
  points: "1,1 2,1 1,2  "
}));

var _ref32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_00000041999955786470215920000013469123034672033722_",
  points: "1,1 2,1 1,2  "
}));

var _ref33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_00000090980441771674837090000001836133902192070822_",
  points: "-1,-1 -2,-1 -1,-2  "
}));

var _ref34 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-32",
  className: "st17",
  d: "M781.7,317.5c-0.7,0-1.4,0-2.1,0v-69.2c0.7,0,1.4,0,2.1,0V317.5z M755.3,5.7 c1,0.8,2,1.6,2.9,2.5c0.6,0.6,1.2,1.2,1.7,1.8c0.4,0.4,0.8,0.9,1.1,1.3c0.4,0.5,0.8,1,1.1,1.5c0.5,0.7,0.9,1.3,1.3,2 c0.3,0.5,0.6,1.1,0.8,1.6c0.3,0.5,0.5,1.1,0.8,1.7c0.2,0.4,0.3,0.8,0.5,1.1c0.3,0.8,0.6,1.6,0.8,2.4c0.1,0.4,0.2,0.8,0.3,1.2 c0.2,0.8,0.4,1.7,0.6,2.5c0.1,0.4,0.2,0.9,0.2,1.3c0.1,0.9,0.2,1.8,0.3,2.7c0.1,0.9,0.1,1.9,0.2,2.8c0,1,0.1,2,0,3 c-0.2,18.2-0.3,36.4-0.3,54.6c0,9.1,0,18.2-0.1,27.3c0,3.7,0,7.3,0,11c0,23.6,0,47.2,0,70.9c0,18.2,0,36.4,0,54.6 c0,22.7-0.1,45.4-0.1,68c0,7.6,0,15.1,0,22.7s0,15.1,0,22.7c0,22.7,0,45.3,0.2,68v1.6c0,0.5,0,1-0.1,1.5l0,0 c0,0,1.8,106.7-15.8,106.5c2.3,0.3,4.7,0.5,7,0.8c0.8,0,1.5,0,2.3,0c1.9-0.4,3.8-0.7,5.7-1.1c13.6-7.5,19.2-19.1,18.9-34.6 c-0.3-15,0.5-30,0.8-45l0.3-301.1c-1.1-44.6,1.5-89.3-1.3-133.8C784,7.2,770.7-2.7,748.3,1.4c2.2,1.1,4.2,2.3,6,3.5 C754.6,5.2,755,5.5,755.3,5.7L755.3,5.7z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-33",
  className: "st10",
  d: "M546.2,511.7c1.7,2.8,3.9,5.1,6.6,6.8C550.4,516.9,548.1,514.7,546.2,511.7"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-34",
  className: "st1",
  d: "M754.8,43.8c-0.1,7.2-0.1,14.4-0.1,21.6c0,14.8,0,29.5,0,44.3c0,19.5-0.1,39-0.1,58.5 c0,34.3,0,68.5,0,102.8c0,0.9,0,1.8,0.1,2.6c-0.1,13.8-0.1,27.5-0.2,41.3c0,1.3,0.1,2.5,0.1,3.8c0,3.4,0.1,6.9,0.1,10.3 c0.2,29.2,0.5,58.3,0.7,87.5v11.7l-0.1,33.1v5.8v5.4l0,0c0,1.8-0.5,3-1.4,3.8c-2.2,1.9-7.8,0.8-7.8,0.8l-180.4-16h-0.3 c-12.1-1.1-12.7-5.5-12.6-6.7c0-0.1,0-0.2,0-0.3c0.1-0.7,0.1-68.8,0.1-76.2c-0.2-10.4-0.3-20.7-0.5-31.1l-0.7-120.2 c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.7,0.1-1.5,0.2-2.2c-0.8-18.6-0.9-37.2,0.2-55.8c-1.6-21.6-1.1-43.1-0.2-64.7 c0.5-12.6,1.5-25.2,0.8-37.7c-0.6-10.5,4.5-13.4,12.7-14.4c0.4,0,0.8-0.1,1.1-0.1c21.1-2.1,42.2-4.3,63.3-6.4 c36.8-3.7,73.6-7.3,110.5-10.9c1.8-0.2,3.6,0,5.4-0.1C753.5,32.9,754.8,37.5,754.8,43.8L754.8,43.8z M540,349 c0.1,30.7,1.8,148.4,1.8,148.4c0.5,6.2,1.9,11.6,4.2,15.1c1.9,3,4.1,4.6,6.5,6.1c5.3,3.5,10.9,3.7,10.9,3.7l69.9,8.3 l107.3,12.7l1.3,0.2l1.4,0.2c3.4,0.7,6.3,1,8.8,1c17.6,0.1,15.8-14,15.8-14v-92.6c0-0.5,0.1-3.1,0.1-3.1 c-0.1-22.7-0.2-45.3-0.2-68c0-7.6,0-15.1,0-22.7s0-15.1,0-22.7c0-22.7,0.1-45.4,0.1-68c0-18.2,0-36.4,0-54.6 c0-23.6-0.1-47.2,0-70.9c0-3.7,0-7.3,0-11c0-9.1,0-18.2,0.1-27.3c0.1-18.2,0.2-36.4,0.3-54.6c0-1,0-2,0-3s-0.1-1.9-0.2-2.8 c-0.1-0.9-0.2-1.8-0.3-2.7c-0.1-0.4-0.1-0.9-0.2-1.3c-0.2-0.9-0.3-1.7-0.6-2.5c-0.1-0.4-0.2-0.8-0.3-1.2 c-0.2-0.8-0.5-1.6-0.8-2.4c-0.1-0.4-0.3-0.8-0.5-1.1c-0.2-0.6-0.5-1.1-0.8-1.7c-0.3-0.5-0.5-1.1-0.8-1.6 c-0.4-0.7-0.8-1.4-1.3-2c-0.4-0.5-0.7-1-1.1-1.5c-0.4-0.5-0.7-0.9-1.1-1.3c-0.5-0.6-1.1-1.2-1.7-1.8c-0.9-0.9-1.9-1.7-2.9-2.5 c-0.3-0.3-0.7-0.5-1.1-0.8c-1.8-1.3-3.8-2.4-6-3.5l0,0c-11,1.1-156.7,18.1-172.4,19.4c-25.1,2.1-35.3,12.9-35.4,38 c-0.1,10.4-0.1,20.8-0.2,31.3c0,35.1,0.1,70.2,0.1,105.3l0,0l-0.2,69.2c-0.1,0-0.2,0.1-0.3,0.1c0,18,0.1,35.9,0.1,53.9 l-0.1,30.4L540,349z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-45",
  className: "st20",
  d: "M368.2,325.5c0,0,10.4,0.9,15.6-1.3c5.2-2.2,7.1-4.5,9.9-4.1s10.3-1.7,11-2.8 c0.7-1,3.2,2,0.5,4.2c-2.7,2.3-11,5.9-8.8,7.8c2.2,1.8,2.7,2.4,10-0.3c7.3-2.7,18.8,10.7,18.8,10.7s0.2,4.7-5.4,3.5 c0,0-1.3,2.9-5.8,2.4c0,0,0.2,3.5-11.1,1.7c0,0-1,3.3-3.8,3.3c-3.6,0-3.6-1.5-8.5-2.2c-10.4-1.5-24.3-7.9-25.2-10.2 C364.3,334.5,368.2,325.5,368.2,325.5"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-46",
  className: "st21",
  d: "M391,347.4c0,0,11.7-16.8,21-19c0,0,6.4,2.3,13.2,10.2c0,0-0.3,4.8-5.4,3.5 c0,0-1.1,2.8-5.8,2.4c0,0,0.6,3.5-11.1,1.7c0,0-1.7,5.1-7,2.7C395.9,349,391.8,347.5,391,347.4"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-47",
  className: "st22",
  d: "M374.4,324.8c0,0-4.6,13.8,4.5,19.7l-14.5-6.4l7.1-13.3L374.4,324.8L374.4,324.8z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-48",
  className: "st22",
  d: "M405.4,331.4l14.4,10l0.8,0.1C420.2,341.1,405.2,330,405.4,331.4"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-49",
  className: "st22",
  d: "M414,344.5c0,0-9.7-9-12.6-9.2s12.2,10,12.2,10L414,344.5z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-50",
  className: "st22",
  d: "M402.9,345.5c1.8,1.3-8.6-4-7.6-4.6c-0.8,0.4,7.2,5.2,7.2,5.2L402.9,345.5z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-51",
  className: "st20",
  d: "M404,319.2c0,0,12.4-5.6,18.9-5.1s25.5,3.2,25.5,3.2l2.1,18.5c0,0-19.1,1.8-28.2,3.7 s-27.9-6.3-26.6-10.7C397,324.4,404,319.2,404,319.2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-52",
  className: "st22",
  d: "M415.2,327.6c0,0,7.9-0.1,9.5-1.3c0,0,2.7-0.1,2.6,2.8s17.7,2.3,17.7,2.3l1.8,4.4 c0,0-22.9,3.2-23.6,2.9C421.9,338.3,415.2,327.6,415.2,327.6"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-53",
  className: "st22",
  d: "M415.2,327.6c0,0-3.7-1.3-8.8,1.1c-5,2.4-6.7-1.8-6.7-1.8s-0.6,0.9,0.6,2.3 c1.3,1.4,4.2,1.4,8.5-0.3c4.3-1.7,8.8-0.1,8.8-0.1L415.2,327.6z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-54",
  className: "st23",
  d: "M63.1,58.4c0,0.6,0.3,1,0.8,1.1l9.4,0.5h0.1c2,0.1,3.1-1.7,3.4-3.4c0.2-1,0.2-2.1-0.1-3 c-0.3-1.1-0.8-1.9-1.5-2.6L63.1,40V58.4z M63.6,62.8c-1.2-0.1-1.9-0.4-2.4-1.1c-0.6-0.8-0.6-2.1-0.6-3.4V40.2 c0-0.1,0.1-1.5,0.8-2.5l0,0c0.2-0.3,0.9-1.2,1.8-1.2c0.3,0,0.5,0.1,0.7,0.3l12.7,11.4c1.2,1.1,2.1,2.6,2.6,4.4 c0.4,1.6,0.5,3.4,0.1,5c-0.3,1.6-1,3.1-2,4.1c-1.1,1.1-2.4,1.7-3.8,1.6c-0.1,0-0.1,0-0.2,0l-9.4-0.5 C63.8,62.8,63.7,62.8,63.6,62.8L63.6,62.8z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-55",
  className: "st24",
  d: "M63.9,39.6c-0.4,0-0.8,0.4-0.8,1v18.3l12.1-9.5c0.7-0.6,1.3-1.4,1.5-2.4 c0.2-0.9,0.3-2,0.1-3c-0.4-1.7-1.4-3.6-3.4-3.8h-0.1L63.9,39.6z M62.8,62.6c-0.4,0-0.7-0.2-1-0.4c-0.7-0.5-1.1-1.5-1.1-2.6 V40.4c0-2.4,1.5-4.3,3.3-4.2l9.4,0.5c0.1,0,0.1,0,0.2,0c1.4,0.1,2.8,0.8,3.8,2.1c1,1.1,1.7,2.6,2,4.3c0.4,1.7,0.3,3.4-0.1,5 c-0.5,1.7-1.3,3.1-2.6,4.1L64,62.3C63.6,62.5,63.2,62.7,62.8,62.6L62.8,62.6z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-56",
  className: "st23",
  d: "M570.9,74.3c0,0.5,0.3,0.9,0.8,0.9l9.6-0.9h0.1c2-0.2,3.2-2.1,3.6-3.8c0.2-1,0.2-2,0-2.9 c-0.3-1-0.8-1.7-1.5-2.3l-12.3-8.7L570.9,74.3z M571.4,78.5c-1.2,0.1-2-0.1-2.4-0.7c-0.6-0.7-0.6-2-0.6-3.2l0.2-17.5 c0-0.1,0.1-1.5,0.8-2.5l0,0c0.2-0.4,1-1.4,1.8-1.4c0.3,0,0.5,0,0.8,0.2l12.9,9.1c1.2,0.9,2.1,2.2,2.6,3.9 c0.4,1.5,0.4,3.2,0.1,4.9c-0.4,1.7-1.1,3.1-2.1,4.3c-1.1,1.2-2.4,2-3.9,2.2c-0.1,0-0.1,0-0.2,0l-9.6,0.9 C571.5,78.5,571.4,78.5,571.4,78.5L571.4,78.5z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-57",
  className: "st24",
  d: "M571.9,56.1c-0.4,0-0.8,0.5-0.8,1.1l-0.2,17.7l12.5-11.1c0.8-0.7,1.3-1.5,1.6-2.6 c0.3-0.9,0.3-2,0.1-2.9c-0.3-1.6-1.4-3.3-3.5-3.1h-0.1L571.9,56.1z M570.5,78.5c-0.4,0-0.7,0-1.1-0.2c-0.7-0.4-1.1-1.3-1.1-2.3 l0.2-18.6c0-2.3,1.6-4.4,3.4-4.6l9.6-0.9c0.1,0,0.1,0,0.2,0c1.5-0.1,2.8,0.4,3.9,1.4c1,0.9,1.7,2.3,2,3.9 c0.3,1.6,0.3,3.3-0.2,4.9c-0.5,1.7-1.4,3.3-2.7,4.4l-13,11.5C571.3,78.3,570.9,78.5,570.5,78.5L570.5,78.5z"
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-58",
  className: "st25",
  points: "216.1,321.2 190.3,407.8 179.4,372.3 197.7,330.7  "
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-59",
  className: "st26",
  d: "M212,334.7c0,0-28.3,10.3-18.7,62.8l-3.6,11.5c0,0-17.4-58.7,10.4-81.4l14.2-0.6L212,334.7z "
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-60",
  className: "st11",
  d: "M196.1,188.6c0,0,4.5,4.5-14.9,31.2S164,297.4,164,297.4l46.1-55.1l20.5-52.2L196.1,188.6z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-61",
  className: "st20",
  d: "M261.8,137.7c0,0,32.3,6.5,23,37.1c0,0,1.4,13.5,7.4,20.1c0.8,0.9,0.7,2.3-0.3,3 c-1.5,1.1-4,2.6-7.1,3.4l0.4,8.3c0.1,2.5-0.1,5-0.9,7.3c-3.8,11.5-14.9,8.4-33.5,8.9c0,0-22.2-2.5-20.5,21.3 c1.7,23.9-0.1,23.6-0.1,23.6l-29.1-26.4c0,0,23.6-22.7,17.4-58.7S261.8,137.7,261.8,137.7"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-62",
  className: "st22",
  d: "M210.4,231.7c0,0,19.3,34.6,20.3,22.4l3.8,11.9l-15.1-11.4l-11.2-19.9L210.4,231.7z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-63",
  className: "st22",
  d: "M282.9,151.5c0,0-13.8-1.4-22.2,19.9c-8.4,21.3-23.1,40.4-41.6,34.8l0.9-30.3 C219.9,175.9,270.3,117.5,282.9,151.5"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-64",
  className: "st1",
  d: "M205.3,239.5c0,0-9.8,4.8-16.8,10.1c-11.2,8.6-39,85.2-39,85.2s22.6,18.8,44,13.2 c0,0,7.9-13.8,25-23c17.1-9.3,36.4-47.2,23.9-66.7c-3.5-5.4-13.1-18.3-12.1-15.4c9.4,28.5-10.8,16.7-10.8,16.7L205.3,239.5z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-65",
  className: "st26",
  d: "M155.7,318.3c0,0,3.7,27.6,43.1,22.6l-2.9,3.3c0,0-28.8,5.8-44.3-17.5L155.7,318.3z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-66",
  className: "st26",
  d: "M201.1,241.7c0,0,21.7,35,22.6,35.8s8.1-13.5,8.1-13.5s1.3-3.2,10.9,8.9c0,0,5.2,4.3,0-7.8 l-10.9-7.9c0,0,3.9,6.4-9.5,1.2c-17.4-6.9-19.3-17.7-19.3-17.7L201.1,241.7z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-67",
  className: "st26",
  d: "M195.1,299.8c0,0,17.9,16.6,32.2,18.1c0,0,8-9.1,8.4-10.9 C236.2,305.2,195.1,299.8,195.1,299.8"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-68",
  className: "st27",
  d: "M153.6,323.8c0,0,8.4,22.8,44.1,18.3c0,0-15.7,14.6-9.5,41.5c6.2,27,12.8,81.6,12.8,81.6 l-97.9,8.7c0,0-15.4-81.3,7.1-111.9C132.6,331.5,139.5,344.5,153.6,323.8"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-69",
  className: "st28",
  d: "M209.3,233.7c0,0,9.2,19.2,21.7,26.5l-6.9,14.3l-23-35.7 C201.1,238.8,210.1,228.6,209.3,233.7"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-70",
  className: "st28",
  d: "M231,260.2c0,0,9.4,6.6,13.2,12.2c0,0,0.2-11.5-3.4-16.5c-3.6-5-10.4-13.9-10.4-13.9 L231,260.2z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-71",
  className: "st29",
  d: "M203.6,263c0,0,44.5,18.5,63.8,30.1s27.9,13.7,27.9,13.7s9,2.6,16.7,3s50.9,14,50.9,14 l-1.5,15.5c0,0-65.1-3.4-87.6-11.6s-78.6-27.9-78.6-27.9S186.2,259.4,203.6,263"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-72",
  className: "st26",
  d: "M354.6,321.2c0,0-0.1,16.9-18.4,16.3l23.8,1.7l-1.8-17L354.6,321.2z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-73",
  className: "st28",
  d: "M356.8,322c0,0,1.6,4.5-0.6,11.2s-1.7,5.7-1.7,5.7s-2,1.6-0.1,2.4s12.4,2,14.3,0.7 s4.3-16.4,3.7-17.6C372,323.3,353.8,318.3,356.8,322"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-74",
  className: "st0",
  d: "M281.2,149.1c0,0-11.4-10.6-27,28.6s-60.5,20.8-60.5,20.8s-6.3-60.8,47.3-67 C282,126.8,281.2,149.1,281.2,149.1"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-75",
  className: "st30",
  d: "M161.8,334.3c0,0-32.8,24.4-23.3,53.1c9.5,28.6-13.6,84.7-13.6,84.7l76.1-6.8 c0,0-8.4-67.3-13.9-88.7c0,0-2.6-20,10.7-34.5C197.7,342.1,177.2,346.3,161.8,334.3"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  id: "Stroke-77",
  className: "st31",
  d: "M346,436.4c2.1-1.8,4.8-3,6.3-5.3c2.5-3.7,6.8-15.5-1.2-18.4c-7.4-2.7-5.8,10.6-5.7,11.4 c2,12,13.3,17.3-5.8,21.3c-0.6,0.1-0.9-1.6-0.3-1.8l1.5-1.6c8.5-4.2,17-8.5,26-11.8c1.4-0.5-2.3,2-3,3.4 c-0.4,0.7-0.6,1.7-0.2,2.4c0.4,0.9,1.9,1.1,5.1,0.1c1.5-0.5,3.1-1.3,4.2-2.5c0.6-0.6,0-1.9,0.6-2.6c0.4-0.5-0.5,1.5,0,1.8 l0.9,1.8c1,0.7,2.2,1.3,3.4,1.5c1.3,0.3,2.7,0.3,4.1-0.1c3.1-0.8,5.9-2.4,8.9-3.4c1.4-0.4,2.9-0.5,4.3-0.8"
});

var _ref69 = /*#__PURE__*/React.createElement("g", {
  id: "Group-81",
  transform: "translate(410.924370, 413.497908)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke-79",
  className: "st32",
  d: "M6.4,29.5c1.4-5.6,3.2-11.2,4.2-16.9C14-6.5-3.8,9.3,1.3,17.7C9,30.4,39,18.4,33.5,3.2 c-2.3-6.2-12.1-0.8-14,1.1C9,14.5,21.7,29.4,33.5,26.6c7.5-1.8,4.5-13.8,9.1-2.5c0.3,0.8,0.9,1.6,1.5,2.3 c0.3,0.4,0.8,0.7,1.3,0.8c1.2,0.1,2.4,0.2,3.5-0.3s1.9-1.5,2.7-2.4c1.2-1.5,2.1-3.2,3.1-4.8"
}));

var _ref70 = /*#__PURE__*/React.createElement("g", {
  id: "Group-118",
  transform: "translate(437.177871, 123.364017)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-82",
  className: "st33",
  d: "M160.3,135.3c0,0-12.1,10.4-27.1,37.4c-11.7,21-35.3,27.2-35.3,27.2 c1.1-0.1-43.6-1.5-58.7-2.2c-8.1-0.4-25.3-1.3-25.3-1.3l-2.4,21.3c0,0,64.5,13.9,95.9,14.2c6.5,0.1,20-9.8,25.5-11.9 c15.4-6.1,37.8-21.5,37.8-21.5S192.6,135.4,160.3,135.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-84",
  className: "st34",
  d: "M19.2,197.6c0,0-2.8,5.2-3.5,12.8c-0.7,7.6-0.8,6.3-0.8,6.3s1.3,2.4-1,2.4 c-2.2,0-11.9-2.8-13.2-4.9c-1.3-2.1,4-19.2,5.1-20.2C6.8,193.1,20.8,194.9,19.2,197.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-86",
  className: "st35",
  d: "M197.5,243.5l-19.6,98.2l72.8,6.8c0,0,4.8-27.1,13.5-49.4c8.8-22.3,9.2-56.8,9.2-56.8 L197.5,243.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-88",
  className: "st36",
  d: "M200.6,252.1l22.4,94l73.5,6.4c0,0-10.9-54.8-12.2-78.7c-1.4-23.9-15.5-55.4-15.5-55.4 L200.6,252.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-90",
  className: "st20",
  d: "M123.8,7.3c0,0-34.2,6.9-24.4,39.8c0,0-6.4,9.9-7.9,21.6c-0.2,1.3-0.7,2.5,0.3,3.2 c1.6,1.2,4.2,2.8,7.6,3.6l-0.4,9c-0.1,2.7,0.2,5.3,1,7.9c4,12.4,29.3,13.3,35.5,9.6c12.3,13.4,16.4,21.7,17.3,28.4 c3.1,23.1,19.2,14.3,19.2,14.3l16.1-22.9c0,0-25-24.4-18.4-63C176.2,20.3,123.8,7.3,123.8,7.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-92",
  className: "st22",
  d: "M178.2,108.2c0,0-18.3,24.7-24.9,26.5l-0.7,10.3l16-12.2l11.9-21.3L178.2,108.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-94",
  className: "st23",
  d: "M184.7,106.7c0,0,19.2,4.5,28.2,7.2c46.6,14.3,64.3,118.9,64.3,118.9s-53.9,21.7-76.6,15.7 c0,0-20.5-37.3-29.9-50.1c-12.4-16.7-13.7-32.1-23.1-55.1c-2.9-7.2,1.6-23,1.6-23s2.9,5.6,2.9,6c0.4,11.9,1.6,13.8,5.7,13.5 c5-0.4,11.9-11.6,11.9-11.6L184.7,106.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-96",
  className: "st34",
  d: "M195,107.6c0,0-29.9,48.9-30.9,49.7s-8.6-14.5-8.6-14.5l-4.8,12.8c0,0-6.7-12.7-5.3-19.4 l10.1-0.7c0,0-4.1,6.9,10,1.3c18.5-7.4,23.2-30.3,23.2-30.3L195,107.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-98",
  className: "st37",
  d: "M179.4,110.3c0,0-9.8,19.9-23,28.4l7.3,15.3l27.4-47L174,99.7 C174,99.7,177.8,107.4,179.4,110.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-100",
  className: "st37",
  d: "M159.2,141.4c0,0-0.7,6.6-2.8,3.5c-1.3-1.9-6.7,0.9-9.3,5.3c0,0-2.8-7.5-2.6-17.8 c0.1-6.6,4.2-13,4.2-13c-0.2-0.2,1.5,2,3,5.7C153.4,128.9,159.2,141.4,159.2,141.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-102",
  className: "st38",
  d: "M123.7,32.1c-1.5,0.2-13.4-15.4,17.8-9.3c27.4,5.4,24.3,41.7,13.2,52.6 c0,0-1.9-24-13.5-24.8c-2.7-0.2-5,2-5.1,4.7c-0.2,3.9-0.9,10.4-3.6,13.1C132.5,68.4,133.4,48,123.7,32.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-104",
  className: "st39",
  d: "M100.5,19.7c0,0,25.8-21.7,42.3,20.3c6,15.3,17.3,26,21.1,34.6c2.7,6,2.2,5.8,3,8.1 c1.3,3.9,3.8,12.2,4.6,11.6c5.7-3.8,16.9-28.9,19-39.3c3.9-19.3-13.6-50.2-47.4-54.2C99.6-4.2,100.5,19.7,100.5,19.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-106",
  className: "st39",
  d: "M109.8,12.7c4.8,10.2,2.3,13.6,20.7,23.5c25.3,13.5,29.4,39.9,46.7,34.4l8.3-24 C185.5,46.5,121.5-21.1,109.8,12.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-108",
  className: "st40",
  d: "M112.6,102.6c0,0,15.5,3.4,21.2,0.3c5.8-3,6.3-18.9,4.3-24c0,0,1.5,8.6-9.2,13.1 c-2.5,1-16.9,0.9-17.3-1.8c-1.4-9.1-12.1-14.3-12.1-14.3l-1,19.6L112.6,102.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-110",
  className: "st20",
  d: "M247.5,316.6c0,0-3.3,12.8,0.8,20.3c0,0,0.8,4.7,2.8,4.8c2,0.1,14.2,1.1,17.1-3 s4.4-22.6,4.4-22.6L247.5,316.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-112",
  className: "st22",
  d: "M249.3,321.2c0,0,1.8,15-1,15.8c0,0,0.7,4.7,2.8,4.8c2.1,0.1,0.1-24.8,0.1-24.8 L249.3,321.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-114",
  className: "st33",
  d: "M203.8,135.1c0,0,12.3,50.6,22.6,72.2c10.4,21.6,14.6,29.2,14.6,29.2s0.6,15.1,0.2,23.3 c-0.4,8.1,7.8,43.3,7.8,43.3l21.9,6c0,0,5.1-74.6-1.4-99.2c-5.8-22.2-22-63.8-25.4-70.2c-3.4-6.3-9.3-12.7-10.2-13.3 C227.5,122.1,208.7,107.1,203.8,135.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-116",
  className: "st34",
  d: "M249.8,302.5c0,0,5.9,2.8,13.3,1.2c7.4-1.6,6.3-1.2,6.3-1.2s1.9-1.9,2.6,0.2 s1.7,12.6,0.1,14.5s-24.1,0.7-25.3-0.1C245.5,316.4,246.1,298.9,249.8,302.5"
}));

var _ref71 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-44",
  className: "st41",
  points: "351.5,295 448,295 448,266.4 351.5,266.4  "
});

var _ref72 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 361 288)",
  className: "st42 st43 st44"
}, "SIGNED");

const SvgNominationSignedIllustration = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 815 546",
    style: {
      enableBackground: "new 0 0 815 546"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Get-Started---Nomination-overview",
    transform: "translate(-428.000000, -122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(428.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Group-76"
  }, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref31, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065752997241155497970000002363981062419368338_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _ref32, _ref33, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134940507729415413250000003803908255164525963_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041999955786470215920000013469123034672033722_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171685411218467824760000004711661518316417439_",
    style: {
      clipPath: "url(#SVGID_00000134940507729415413250000003803908255164525963_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090980441771674837090000001836133902192070822_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    style: {
      clipPath: "url(#SVGID_00000171685411218467824760000004711661518316417439_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BAD4E8"
    },
    d: " M767.6,117.1c0,3.7,0,7.3,0,11C767.6,124.5,767.6,120.8,767.6,117.1"
  }))), _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67), _ref68, _ref69, _ref70), _ref71, _ref72))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNominationSignedIllustration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Nomination_signed_Illustration.207d1f86.svg";
export { ForwardRef as ReactComponent };